module.exports = __webpack_public_path__ + "static/media/1.f8a7a2f2.png";